<template>
  <ns-button id="quiq-chat-button" @click="startChat" :class="chatType" class="btn btn-primary" :disabled="disabled" :href="href">{{buttonDisplayName}}</ns-button>
</template>

<script>
import {BrowserDetection, events} from '@nuskin/ns-util';
// import NsButton from '../ns-button/ns-button'
export default {
    name: "NsQuiqChatButtonVue",
    // components: {
    //     NsButton
    // },
    props: {
      /**
       * The visible text on the button.
       */
      buttonDisplayName: {
          type: String,
          default: "Default"
      },
      /**
       * The contact point used by QuiqChat.
       */
      chatType: {
          type: String,
          default: "customer-order-support"
      },
      /**
       * The support number to contact.
       */
      phoneNumber: {
          type: String
      },
      disabled: {
          type: Boolean,
          default: false
      },
      /**
       * This will force the web client on a mobile device
       */
      useWebClientAlways: {
          type: Boolean,
          default: false
      },
      /**
       * Tenant that will be used to initialize quiq chat API
       */
      tenant: {
          type: String,
          default: "nuskin"
      }
    },
    data: function() {
      return {
        href: "#",
        /**
          * Initialized and configured QuiqChat object generated by properties passed into the component and the QuiqChat script.
          */
        _chat: {},
        /**
          * Tracks if the connection to QuiqChat is active.
          */
        _quiqChatInitialized: false,
        /**
          * Tracks if the chat window is visible on the screen.
          */
        _chatVisibility: false,

      }
    },
    methods: {
      startChat() {
        if (this._quiqChatInitialized) {
            this._toggleChat();
            return;
        }

        if (typeof Quiq !== "undefined") {
            let newChat = {
                host: `https://${this.tenant}.goquiq.com`,
                contactPoint: this.chatType,
                customLaunchButtons: ["."+this.chatType],
                mobileNumber: this.phoneNumber
            };

            this._chat = Quiq(newChat);

            // Quiq has difficulty finding something on the initial display.
            // Using the getter lets us wait until that something is found and then
            // set its visibility to true. This is to get around using setTimeout.
            this._chat.getChatVisibility( ()=> {
                this._toggleChat();
                this._quiqChatInitialized = true;
                events.publish("quiq-chat-initialized", this._chat);
            });

            // listen for close event on popup close button. This will reset the _chatVisibility across all chat buttons to false.
            $("button[data-test='closeChatButton']").unbind().click(function(e) {
                events.publish("quiqChatClosed");
            });

            Array.from(document.querySelectorAll('ns-quiq-chat-button'))
                .filter(item => item.localName === 'ns-quiq-chat-button' && item !== this)
                .map(btn => {
                    btn.disabled = true;
                    return btn;
                });
          }
      },
      _toggleChat() {
          if (!BrowserDetection.isMobile()) {
              this._chatVisibility = !this._chatVisibility;
              this._chat.setChatVisibility(this._chatVisibility);
          }
      }
    },
    mounted: function() {
      events.subscribe("quiq-chat-initialized", (chat) => {
          this._quiqChatInitialized = true;
          this._chat = chat;
      });
      events.subscribe("quiq-chat-visibility", () => {
      });
      events.subscribe("quiqChatClosed", () => {
          this._chatVisibility = false;
      });
      if (BrowserDetection.isMobile() && !this.useWebClientAlways) {
          this.href = "sms:" + this.phoneNumber;
      }
    }
}

</script>